import React, {Component} from "react"
import {Entity} from "aframe-react"

import IdeaBox from './ideaBox.js'

class Boxes extends Component {


    render() {
        return (
            <Entity position={{x:0, y: 1.6, z:0}}>

                {this.props.sceneItems.map( (item, index)  => {

                    return (
                        <IdeaBox 

                            item={item}
                            actions={this.props}

                            rotation={item.rotation} 

                            dKey={index} key={item.id} 
                        />
                    );

                })}

            </Entity>
        )
    }
}

export default Boxes;



// WEBPACK FOOTER //
// ./src/components/boxes.js